const BASENAME = '/user';

enum Path {
  LOGIN = '/login',
  QUIZ_HOME = '/quiz',
  QUIZ = '/quiz/*',
  QUIZ_MEN = '/quiz/men',
  QUIZ_WOMEN = '/quiz/women',
  QUIZ_REGISTER = '/quiz/register',
  RECOVER_PASSWORD = '/recover-password',
  RETURN_ORDER = '/my-lk-return/shipments/:serviceId',
  HOME = '/my-area',
  REFERRALS = '/referrals',
  REFERRALS_SUMMARY = '/referrals/summary',
  STYLE_PROFILE_HOME = '/style-profile',
  STYLE_PROFILE = '/style-profile/*',
  ACCOUNT = '/account',
  ACCOUNT_MY_PLAN = '/account/my-plan',
  DELETE_ACCOUNT = '/delete-account',
  DELETE_ACCOUNT_CONFIRM = '/delete-account-confirm',
  DELETE_ACCOUNT_SUCCESS = '/delete-account-success',
  DELETE_ACCOUNT_ERROR = '/delete-account-error',
  CANCEL_BOX_FLOW = '/cancel-box/*',
  CANCEL_BOX = '/cancel-box',
  CANCEL_BOX_CONFIRM = '/cancel-box/confirm',
  CANCEL_BOX_SUCCESS = '/cancel-box/success',
  CANCEL_BOX_ERROR = '/cancel-box/error',
  PROFILE_MENU = '/profile',
  LOOK_IN = '/shop/*',
  LOOK_IN_HOME = '/shop',
  LOOK_IN_ORDERS = '/shop/orders',
  CHECKOUT = '/checkout/*',
  CHECKOUT_HOME = '/checkout',
  FAQS = '/faqs',
  SUPPORT = '/support',
  // Native Paths
  INBOX = '/inbox',
  INTRO = '/intro',
  NEWSFEED = '/news',
  ONBOARDING = '/onboarding',
  LOOK_AND_LIKE = '/look-and-like',
}

enum MyAreaSlug {
  ORDER = 'order',
  PLACED = 'placed',
  TRACKING = 'tracking',
  CHECKOUT_PREVIEW = 'checkout-preview',
}

const MY_AREA_PATH = {
  ORDER: `${Path.HOME}/${MyAreaSlug.ORDER}`,
  PLACED: `${Path.HOME}/${MyAreaSlug.PLACED}`,
  TRACKING: `${Path.HOME}/${MyAreaSlug.TRACKING}`,
  CHECKOUT_PREVIEW: `${Path.HOME}/${MyAreaSlug.CHECKOUT_PREVIEW}`,
} as const;

type MyAreaPathType = (typeof MY_AREA_PATH)[keyof typeof MY_AREA_PATH];

enum PlaceOrderSlug {
  SUBSCRIPTION = 'subscription',
  SCHEDULE = 'schedule',
  SHIP = 'ship',
  PAY = 'pay',
}

const PLACE_ORDER_PATH = {
  SUBSCRIPTION: `${MY_AREA_PATH.ORDER}/${PlaceOrderSlug.SUBSCRIPTION}`,
  SCHEDULE: `${MY_AREA_PATH.ORDER}/${PlaceOrderSlug.SCHEDULE}`,
  SHIP: `${MY_AREA_PATH.ORDER}/${PlaceOrderSlug.SHIP}`,
  PAY: `${MY_AREA_PATH.ORDER}/${PlaceOrderSlug.PAY}`,
} as const;

type PlaceOrderPathType = (typeof PLACE_ORDER_PATH)[keyof typeof PLACE_ORDER_PATH];

const withWildcard = (path: string): string => (path.endsWith('/*') ? path : `${path}/*`);

const paymentReturnPath = (pathname: string): string =>
  pathname.startsWith(MY_AREA_PATH.ORDER) ? Path.HOME : pathname;

export {BASENAME, MY_AREA_PATH, MyAreaSlug, PLACE_ORDER_PATH, PlaceOrderSlug, Path, paymentReturnPath, withWildcard};
export type {MyAreaPathType, PlaceOrderPathType};
